import React from 'react';
import axios from 'axios';

import { useTimeModal } from '../TimeModal/TimeModalContext';
import { formatDateTime, isWithinLastHalfHour } from '../../Utils/GlobalUtils';

import WarningPanel from '../WarningPanel';
import Loading from '../Loading';

import AddNewCommentToCase from './AddNewCommentToCase';

import styles from '../../styles/CommentsCase.module.css';

import ButtonWithConfirmation from '../ButtonWithConfirmation';

const CommentsCase = ({ caseId, access, userId, preTypeComment, preComment, reload, setReload, onSuccess }) => {
    const { openTimeModal } = useTimeModal();

    const [selectedType, setSelectedType] = React.useState('message');
    const [comments, setComments] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    const [warning, setWarning] = React.useState('');

    React.useEffect(() => {
        const token = localStorage.getItem('token');

        axios.get(`/api/get-case-comments?caseId=${caseId}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
        .then(response => {
            if (response.data.length === 0) {
                setComments([]);
            } else {
                setWarning('');
                setComments(response.data);
            }
        })
        .catch(error => {
            setWarning(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`);
            setComments([]);
        })
        .finally(() => {
            setLoading(false);
            setReload(false);
        })
    }, [reload, caseId]);

    const deleteComment = (commentId) => {
        axios.delete(`/api/delete-case-comment?commentId=${commentId}`)
        .then(() => {
            onSuccess();
        })
        .catch(() => {
            openTimeModal('Ошибка при удалении комментария', 'error');
        })
        .finally(() => {
            setReload(true);
        });
    };

    return (
        <>
            {loading ? <Loading />
            : warning ? <WarningPanel text={warning} />
            : 
            <>
                <div className='radioSwitchWrapper'>
                    <label className={`radioSwitchLabel ${selectedType === 'message' ? 'selected' : ''}`}>
                        <input
                            type='radio'
                            name='typeSelector'
                            value='message'
                            checked={selectedType === 'message'}
                            onChange={(e) => setSelectedType(e.target.value)}
                        />
                        <span>Сообщения ({comments.filter((c) => c.type === "message").length})</span>
                    </label>
                    <label className={`radioSwitchLabel ${selectedType === 'change_data' ? 'selected' : ''}`}>
                        <input
                            type='radio'
                            name='typeSelector'
                            value='change_data'
                            checked={selectedType === 'change_data'}
                            onChange={(e) => setSelectedType(e.target.value)}
                        />
                        <span>События ({comments.filter((c) => c.type === "change_data").length})</span>
                    </label>
                </div>

                <AddNewCommentToCase 
                    caseId={caseId} 
                    access={access} 
                    userId={userId} 
                    preType={preTypeComment} 
                    preComment={preComment} 
                    onSuccess={() => {setReload(true); setSelectedType('message');}} 
                />

                <div className={styles.commentsWrapper}>
                {comments
                .filter((comment) => comment.type === selectedType)
                .map((comment) => (
                    <div 
                        key={comment.id}
                        className={`
                            ${styles.comment}
                            ${comment.status=='Удалено' ? styles.deletedComment : ''}
                            ${comment.type=='appointment_refusal' ? styles.appointmentRefusal : ''}
                        `}
                        style={comment.status=='Удалено' ? {opacity: '.5'} : {}}
                    >
                        <span className={`${styles.headerCmt}`}>
                            <p>{comment.user_lastname ? `${comment.user_lastname} ${comment.user_firstname}` : 'Системное сообщение'}</p> 
                            <p className={styles.dateCmt}>{formatDateTime(comment.created_at)}</p>
                            {comment.mailing_status=='Письмо отправлено' && <p className={styles.dateCmt}>Важное сообщение</p>}
                            {comment.status=='Удалено' && <p className={styles.dateCmt}>[Сообщение удалено]</p>}
                        </span>
                        <span className={styles.mainCmt}>
                            <div className={styles.leftSideCmt}>
                                <p>{comment.content}</p>
                            </div>
                            <div className={styles.rightSideCmt}>
                                {((comment.status!=='Удалено' && access) || (comment.initiator_id==userId && isWithinLastHalfHour(comment.created_at))) && <ButtonWithConfirmation id={comment.id} entryFunc={() => deleteComment(comment.id)} />}
                            </div>
                        </span>
                    </div>
                ))}
                </div>
            </>}
        </>
    )
}

export default CommentsCase;